<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div id="formTable">
        <div class="formTableItem">
          <p class="label">时间范围</p>
          <start-end
            ref="startEnd"
            timeModel="0,1,2"
            :datetime="true"
          ></start-end>
        </div>
        <div class="formTableItem">
          <p class="label">选择车辆</p>
          <selecAlotCCar
            ref="selecAlotCCar"
            @deviceIdList="searchItem.deviceIdList = $event"
          ></selecAlotCCar>
        </div>
        <div class="formTableItem">
          <p class="label">行驶里程(大于)</p>
          <InputNumber v-model="searchItem.mileage"></InputNumber>/km
        </div>
        <div class="formTableItem">
          <p class="label">行车时长(大于/分)</p>
          <InputNumber v-model="searchItem.duration"></InputNumber>
        </div>
        <div class="formTableItem">
          <Button @click="exportAll" class="chaxun">导出</Button>
          <Button @click="chaxun" type="primary" class="chaxun">查询</Button>
        </div>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(220)"
    >
      <template slot-scope="{ row, index }" slot="status">
        <Tag
          :title="row.state == 0 ? '' : row.stateDes"
          :color="status[row.state].color"
          >{{ status[row.state].name }}</Tag
        >
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">纠正</Button>
        <Button size="small" @click="guiji(row, index)">轨迹</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model title="纠正里程" width="400" ref="formModel">
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <form-model
      :overAuto="true"
      title="行车轨迹"
      width="400"
      ref="map"
      fullscreen
    >
      <div slot="topcontent" style="width: 100%; height: 100%">
        <locusMap ref="locusMap"></locusMap>
      </div>
    </form-model>
  </div>
</template>
<script>
import locusMap from "../map20/locusMap.vue";
export default {
  components: { locusMap },
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 70,
          align: "center"
        },
        {
          title: "车牌号",
          key: "carNo",
          width: 130
        },
        {
          title: "设备号",
          key: "deviceNo"
        },
        {
          title: "单位名称",
          key: "groupName"
        },
        {
          title: "驾驶员",
          key: "driverName"
        },
        {
          title: "行驶里程",
          key: "mileage"
        },
        {
          title: "行驶时长/分",
          key: "duration"
        },
        {
          title: "开始地点",
          key: "startAdd",
          width: 300
        },
        {
          title: "结束地点",
          key: "endAdd",
          width: 300
        },
        {
          title: "开始时间",
          key: "startTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.startTime));
          },
          width: 130
        },
        {
          title: "结束时间",
          key: "endTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.endTime));
          },
          width: 130
        },
        {
          title: "行车周边标注点",
          key: "startRulePointNames"
        },
        {
          title: "停车周边标注点",
          key: "endRulePointNames"
        },
        {
          title: "数据状态",
          slot: "status",
          sort: 200,
          width: 130,
          align: "center"
        },
        {
          title: "处理时间",
          key: "endTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.handleTime));
          },
          width: 130,
          sort: 21
        },
        {
          title: "处理账号",
          key: "handleAccount",
          sort: 21
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 130,
          align: "center",
          fixed: "right"
        }
      ],
      tableData: [],
      total: 0,
      searchItem: {
        deviceIdList: [],
        driverIdList: [],
        endTime: 0,
        startTime: 0,
        pageSize: 50,
        pageNumber: 1
      },
      forms: [
        {
          title: "纠正里程",
          key: "correctMileage",
          type: "InputNumber",
          required: true,
          span: 24,
          sort: 20
        },
        {
          title: "处理原因",
          key: "handleCause",
          type: "Input",
          required: false,
          span: 24,
          sort: 20
        }
      ],
      item: {
        correctMileage: 0,
        handleCause: ""
      },
      openMap: true,
      status: {
        0: { name: "正常", color: "green" },
        1: { name: "异常", color: "error" }
      }
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.report + "/driving/list",
        data: this.searchItem
      }).then(res => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data.dataList;
          this.tableData = data;
          console.log("xingchebaob", data);
          //console.log(data);
          //this.jiexis();
          //this.jiexis1();
        }
      });
    },
    exportAll() {
      var params = [
        {
          name: "deviceIdList",
          value: this.searchItem.deviceIdList
        },
        {
          name: "driverIdList",
          value: this.searchItem.driverIdList
        },
        {
          name: "startTime",
          value: this.searchItem.startTime
        },
        {
          name: "endTime",
          value: this.searchItem.endTime
        }
      ];
      this.utils.exportData(this.axios.report + "/driving/export/list", params);
    },
    opemUpdate(row) {
      this.item.id = row.id;
      console.log(row);

      this.$refs.formModel.reach(this.forms, this.item);
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;

      this.axios({
        method: "post",
        url: this.axios.report + "/driving/handle",
        data: this.item
      }).then(res => {
        if (res) {
          this.$refs.formModel.close();
          this.getList();
        }
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    search() {
      this.reset();
      this.getList();
    },
    guiji(x) {
      this.$refs.map.reach([], {});
      let params = {
        deviceNo: x.deviceNo,
        returnCoord: 2, //返回坐标系（1-WGS84，2-GCJ-02，3-BD-09）,可用值:1,2,3
        endTime: x.endTime,
        startTime: x.startTime
      };
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.lbs + "/locus/getPlyLocus",
        data: params
      }).then(res => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        this.otherData = data;
        //如果有轨迹在播放，先销毁
        if (this.$store.state.carMsg.play != 1) {
          this.$refs.gmap.play(4);
          this.$store.state.carMsg.play = 1;
        }
        if (res.data.code == 200) {
          if (data.length >= 1) {
            var lnglat = [];
            for (const i in data) {
              lnglat.push([data[i].returnX, data[i].returnY]);
              data[i].tms = data[i].gpsTime / 1000;
              data[i].locateLng = data[i].returnX;
              data[i].locateLat = data[i].returnY;
              data[i].gpsTime1 = this.utils.time(data[i].gpsTime);
              data[i].reportTime = this.utils.time(data[i].reportTime);
              data[i].startParkTime = this.utils.time(data[i].startParkTime);
              data[i].endParkTime = this.utils.time(data[i].endParkTime);
              data[i].parkDuration1 = this.utils.duration(data[i].parkDuration);
              //console.log(data[i].directionDegree,data[i].deviceStatus,data[i].mileage);
            }

            this.$refs.locusMap.loadUi(lnglat, data); //渲染轨迹
            if (this.showPark) {
              this.$refs.gmap.showpark(this.otherData, this.duration); //停车点
            }
            this.$store.state.control = true;
          } else if (data.length == 0) {
            this.$Message.error("暂无轨迹");
            this.$refs.gmap.loadUi([], []); //清空轨迹
            this.$refs.gmap.showpark([], 0); //清空停车点
            this.$store.state.control = false;
          }
        } else {
          this.$Message.error(res.data.message);
        }
      });
    },
    jiexis(row, index) {
      //row.address = 12345677;
      var h = this.tableData;
      var pointList = [];
      for (let i = 0; i < h.length; i++) {
        pointList.push({ x: h[i].startX, y: h[i].startY });
      }
      this.utils.jiexi(pointList).then(data => {
        for (let i = 0; i < data.length; i++) {
          h[i].startAdd = data[i].address;
        }
      });
      //console.log(this.historyData[1].address);
      //console.log(this.historyData[2].address);
    },
    jiexis1(row, index) {
      //row.address = 12345677;
      var h = this.tableData;
      var pointList = [];
      for (let i = 0; i < h.length; i++) {
        pointList.push({ x: h[i].endX, y: h[i].endY });
      }
      this.utils.jiexi(pointList).then(data => {
        for (let i = 0; i < data.length; i++) {
          h[i].endAdd = data[i].address;
        }
      });
      //console.log(this.historyData[1].address);
      //console.log(this.historyData[2].address);
    }
  },
  mounted() {
    var config = {
      min: 100,
      max: 300
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.chaxun();
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// ../common/src/components/report/driving.vue